import { Link } from "react-router-dom";
import GetQuote from "../GetQuote";
import styles from "./Banner.module.css";

const DEFAULT_BANNER_BG = "/banner-bg.webp";

function getBannerBackground({ BannerBgImg, centered, form }) {
  const resolvedBannerBg =
    BannerBgImg && BannerBgImg !== "home" && BannerBgImg !== "default"
      ? BannerBgImg
      : DEFAULT_BANNER_BG;

  if (centered) {
    return `linear-gradient(180deg, rgba(4, 24, 49, 0.52), rgba(4, 24, 49, 0.68)), url(${resolvedBannerBg})`;
  }

  if (BannerBgImg === "home" || form) {
    return `url(${resolvedBannerBg})`;
  }

  if (BannerBgImg === "about") {
    return `url(${resolvedBannerBg})`;
  }

  if (BannerBgImg) {
    return `url(${resolvedBannerBg})`;
  }

  return `linear-gradient(180deg, rgba(255, 255, 255, 0.88), rgba(255, 255, 255, 0.94)), url(${resolvedBannerBg})`;
}

function BannerButton({ btnText, btnLink }) {
  if (!btnText || !btnLink) {
    return null;
  }

  return (
    <Link to={btnLink} className={styles.bannerButton}>
      {btnText}
    </Link>
  );
}

function BannerImage({ BannerColImg, heading }) {
  if (!BannerColImg) {
    return null;
  }

  return (
    <div className={styles.visualWrap}>
      <img src={BannerColImg} alt={heading} className={styles.visualImage} />
    </div>
  );
}

export default function BannerComp({
  heading = "",
  paragraph = "",
  btnText = "",
  btnLink = "",
  BannerBgImg = "",
  BannerColImg = "",
  form = false,
  centered = false,
  pageType = "",
}) {
  const bannerBackground = getBannerBackground({
    BannerBgImg,
    centered,
    form,
  });

  if (!heading) {
    return null;
  }

  if (
    !form &&
    !centered &&
    (!paragraph || !btnText || !btnLink || !BannerColImg)
  ) {
    return null;
  }

  if (form) {
    const bannerStyle = {
      backgroundImage: bannerBackground,
    };
    let textColorClass = pageType === "about" ? styles.aboutText : "";

    return (
      <section
        className={`${styles.banner} ${styles.bannerHome}`}
        style={bannerStyle}
      >
        <div className={`container ${styles.homeInner}`}>
          <div className={`${styles.homeContent} ${textColorClass}`}>
            <h1>{heading}</h1>
            <p>{paragraph}</p>
          </div>
          <GetQuote className={styles.homeForm} />
        </div>
      </section>
    );
  }

  if (centered) {
    const bannerStyle = {
      backgroundImage: bannerBackground,
    };

    return (
      <section
        className={`${styles.banner} ${styles.bannerCentered}`}
        style={bannerStyle}
      >
        <div className={`container ${styles.centeredInner}`}>
          <div className={styles.centeredContent}>
            <h1>{heading}</h1>
            {paragraph ? <p>{paragraph}</p> : null}
          </div>
        </div>
      </section>
    );
  }

  const bannerStyle = {
    backgroundImage: bannerBackground,
  };

  return (
    <section className={styles.banner} style={bannerStyle}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.content}>
          <h1>{heading}</h1>
          <p>{paragraph}</p>
          <BannerButton btnText={btnText} btnLink={btnLink} />
        </div>
        <BannerImage BannerColImg={BannerColImg} heading={heading} />
      </div>
    </section>
  );
}
